import { apiClient } from '@/shared/api';
import { handleRequest } from '@/shared/api/apiWrapper';
import type { Session } from '../model/types';

export const refreshSession = async () => {
  const request = () => apiClient.get('/token/refresh');
  const response = await handleRequest<Session>(request);
  return response.data;
};

export const logout = async () => {
  const request = () => apiClient.delete('/token/revoke');
  const response = await handleRequest(request);
  return response.data;
};
